import ExamSectionTemplate from '@/pages/ExamSectionTemplate';

const faqs = [
  {
    question: "What is CBEAD certification?",
    answer: "CBEAD (Competency-Based Examination in Aesthetic Dentistry & Facial Aesthetics) validates competency in aesthetic dentistry and perioral facial aesthetics for registered dental practitioners. It assesses smile design, perioral injectables, and collaborative aesthetic practice."
  },
  {
    question: "Can dentists perform facial aesthetic procedures?",
    answer: "Dental practitioners must ensure all aesthetic procedures comply with Dental Council regulations in their jurisdiction. CBEAD focuses on perioral aesthetics within the dental scope of practice. Practitioners must maintain active Dental Council registration and comply with local regulatory requirements."
  },
  {
    question: "What procedures does CBEAD cover?",
    answer: "CBEAD covers perioral anatomy, dental injectables (botulinum toxin for masseter, perioral fillers), smile design and harmony assessment, gummy smile correction, bruxism management with botulinum toxin, and scope-of-practice ethics."
  },
  {
    question: "How does CBEAD differ from CBEAM?",
    answer: "CBEAM is designed for medical doctors covering full-face aesthetic medicine. CBEAD is specifically designed for dental practitioners focusing on perioral aesthetics within the dental scope of practice. The anatomical focus, regulatory framework, and scope considerations differ significantly."
  },
  {
    question: "What are the eligibility requirements for CBEAD?",
    answer: "CBEAD requires valid dental registration, active Dental Council registration, minimum 2 years post-qualification clinical experience, evidence of aesthetic dental training, and current professional indemnity insurance."
  },
  {
    question: "Do Dental Council regulations affect CBEAD certification?",
    answer: "Yes, CBEAD certification is subject to Dental Council scope-of-practice regulations. Annual declaration of regulatory compliance is required, and practitioners must ensure their practice remains within the legal scope defined by their Dental Council registration."
  }
];

export default function AestheticDentistryPage() {
  return (
    <ExamSectionTemplate
      sectionTitle="Section of Aesthetic Dentistry"
      examCode="CBEAD"
      ipcfBadge="Level 6 Practitioner Certification"
      examFullName="Competency-Based Examination in Aesthetic Dentistry & Facial Aesthetics"
      testIdPrefix="cbead"
      fee="₹32,000"
      faqs={faqs}
      overview="CBEAD assesses competency in aesthetic dentistry and perioral facial aesthetics for registered dental practitioners. The examination validates clinical knowledge, procedural skills in perioral injectables, smile harmony assessment, and collaborative practice within the aesthetic medicine team."
      eligibility={[
        'Valid dental registration in home jurisdiction',
        'Active Dental Council registration',
        'Minimum 2 years post-qualification clinical experience',
        'Evidence of training in aesthetic dental procedures',
        'Professional references from registered dental practitioners',
        'Current professional indemnity insurance',
      ]}
      stages={[
        { title: 'Written Examination', desc: 'Comprehensive written assessment covering aesthetic dentistry principles and facial harmony.' },
        { title: 'OSCE (Perioral Focus)', desc: 'Clinical examination stations focusing on perioral injectables, smile design, and facial harmony assessment.' },
        { title: 'Case Log Submission', desc: 'Documented clinical cases demonstrating range of aesthetic dental procedures performed.' },
        { title: 'Viva Defense', desc: 'Oral examination assessing clinical reasoning, complication management, and ethical practice.' },
      ]}
      coreDomains={[
        'Perioral Anatomy',
        'Dental Injectables',
        'Smile Design & Harmony',
        'Gummy Smile Correction',
        'Bruxism Management',
        'Scope of Practice Ethics',
      ]}
      certificationValidity={[
        'Initial certification valid for 5 years from date of issue',
        'Certificate verifiable through IMCAC public verification portal',
        'Certification title: Board Certified in Aesthetic Dentistry & Facial Aesthetics (IMCAC – CBEAD)',
        'Certification subject to Dental Council scope-of-practice regulations',
        'Annual declaration of regulatory compliance required',
      ]}
      recertificationPolicy={[
        'Recertification required every 5 years',
        'Minimum 20 CPD hours per year in aesthetic dental procedures',
        'Evidence of continued clinical practice within scope',
        'Compliance with Dental Council regulations',
        'Updated regulatory compliance declaration',
      ]}
      additionalDisclaimer="Dental practitioners must ensure all aesthetic procedures comply with Dental Council regulations in their jurisdiction. This certification does not authorize procedures outside the scope permitted for dental professionals. Practitioners must maintain active Dental Council registration and comply with all local regulatory requirements."
      disclaimer="Certification validates assessed competencies within aesthetic dentistry and does not grant medical licensure. Practice must remain within the legal scope defined by the candidate's Dental Council registration."
      applyLink="/apply"
    />
  );
}
